import CrudTable from "../../components/CrudTable";

export const CATEGORY_TYPES = [
  { value: "income", label: "Gelir Faturası" },
  { value: "expense", label: "Gider Faturası" },
  { value: "fis", label: "Fiş (Gider)" },
];
const ALL_TYPE_VALUES = CATEGORY_TYPES.map((t) => t.value);
const typeLabel = (v) => CATEGORY_TYPES.find((t) => t.value === v)?.label || v;
const typesOf = (it) => (Array.isArray(it.types) && it.types.length ? it.types : ALL_TYPE_VALUES);

const nameValidate = (v, f, items, editId) => {
  if (!String(v || "").trim()) return "Kategori adı zorunludur";
  if (items.some((i) => i.id !== editId && (i.name || "").trim().toLocaleLowerCase("tr") === String(v).trim().toLocaleLowerCase("tr"))) return "Bu kategori zaten kayıtlı";
  return "";
};
const orderValidate = (v) => {
  const n = parseFloat(String(v).replace(",", "."));
  if (isNaN(n)) return "Geçerli bir sıra numarası girin";
  if (n < 0) return "Sıra 0 veya büyük olmalı";
  return "";
};

const CAT_DEFAULTS = { name: "", order: "", types: ALL_TYPE_VALUES };
const CAT_COLUMNS = [
  { key: "order", label: "Sıra", align: "right" },
  { key: "name", label: "Kategori" },
  { key: "types", label: "Tür", render: (it) => typesOf(it).map(typeLabel).join(", "), values: (it) => typesOf(it).map(typeLabel) },
];
const CAT_FIELDS = [
  { key: "name", label: "Kategori Adı", type: "text", validate: nameValidate },
  { key: "order", label: "Sıra", type: "number", validate: orderValidate },
  { key: "types", label: "Tür (hangi belge türlerinde listelensin)", type: "multiselect", options: CATEGORY_TYPES, validate: (v) => (Array.isArray(v) && v.length ? "" : "En az bir tür seçin") },
];

export default function ExpenseCategories() {
  return <CrudTable resource="expense-categories" title="" subtitle="" testidPrefix="expkategori" defaults={CAT_DEFAULTS} columns={CAT_COLUMNS} fields={CAT_FIELDS} />;
}
